import React, { useState, useEffect, useRef } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/reports.css";
import SideNav from "../../components/layout/sideNav";
import { useToast } from "../../context/toastContext";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import moment from "moment-timezone";
import DOMPurify from "dompurify";
import { convertCurrency } from "../../utils/currencyConverter";
import { storageManager } from "../../utils/storageManager";
import { getTimezoneByCountry } from "../../utils/getTimezoneByCountry";

const ReportsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [isFiltersWindowActive, setisFiltersWindowActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("PublisherInfo")) || {}
  );
  const country = userInfo?.country?.toLowerCase() || "india";
  const [filters, setFilters] = useState([
    { name: "affClickId", label: "Aff Click ID", state: false },
    { name: "subAffId", label: "Sub Aff ID", state: false },
    { name: "fbclid", label: "FB Click Id", state: false },
    { name: "goalName", label: "Goal", state: false },
    { name: "source", label: "Source", state: false },
    { name: "gaid", label: "GAID", state: false },
    { name: "ip", label: "IP", state: false },
    { name: "userAgent", label: "User Agent", state: false },
    { name: "campName", label: "Name", state: false },
    { name: "campID", label: "ID", state: false },
    { name: "clickedAt", label: "Click Time", state: false, isTime: true },
    { name: "trackedAt", label: "Conv Time", state: false, isTime: true },
    { name: "timeGap", label: "Time Gap", state: false, isTimeGap: true },
    { name: "value", label: "Payout", state: false, isMoney: true },
    { name: "sub2", label: "Sub 2", state: false, isSubParm: true },
    { name: "sub3", label: "Sub 3", state: false, isSubParm: true },
    { name: "sub4", label: "Sub 4", state: false, isSubParm: true },
    { name: "sub5", label: "Sub 5", state: false, isSubParm: true },
    { name: "sub6", label: "Sub 6", state: false, isSubParm: true },
    { name: "sub7", label: "Sub 7", state: false, isSubParm: true },
    { name: "sub8", label: "Sub 8", state: false, isSubParm: true },
    { name: "isp", label: "ISP", state: false },
    { name: "country", label: "Country", state: false },
  ]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [toShow, setToShow] = useState("summary");
  const [summaryInfo, setSummaryInfo] = useState([]);
  const [includegoalNamesInSummary, setincludegoalNamesInSummary] =
    useState(false);
  const [reports, setReports] = useState([]);
  const [tabelLoader, settabelLoader] = useState(true);
  const [fetchingData, setfetchingData] = useState(true);
  const reportLoadLimit = 50;
  const [lastApiHit, setLastApiHit] = useState("summaryNoGoals");
  const [currentMonth, setCurrentMonth] = useState(moment().startOf("month"));
  const [startTime, setStartTime] = useState(
    moment.tz(getTimezoneByCountry(country)).startOf("day").format("DD-MM-YYYY")
  );
  const [endTime, setEndTime] = useState(
    moment.tz(getTimezoneByCountry(country)).endOf("day").format("DD-MM-YYYY")
  );
  const [selectedStartTime, setselectedStartTime] = useState(
    moment.tz(getTimezoneByCountry(country)).startOf("day").format("DD-MM-YYYY")
  );
  const [selectedEndTime, setselectedEndTime] = useState(
    moment.tz(getTimezoneByCountry(country)).endOf("day").format("DD-MM-YYYY")
  );
  const [prevStartTime, setPrevStartTime] = useState(
    moment.tz(getTimezoneByCountry(country)).startOf("day").format("DD-MM-YYYY")
  );
  const [prevEndTime, setPrevEndTime] = useState(
    moment.tz(getTimezoneByCountry(country)).endOf("day").format("DD-MM-YYYY")
  );
  const [timezone, setTimezone] = useState(getTimezoneByCountry(country));
  const [prevTimezone, setPrevTimezone] = useState(getTimezoneByCountry(country));
  const [showTimezoneDropdown, setShowTimezoneDropdown] = useState(false);
  const [campIds, setCampIds] = useState([]);
  const [prevCampIds, setPrevCampIds] = useState([]);
  const [campaignSearchText, setCampaignSearchText] = useState("");
  const [campSearchResult, setcampSearchResult] = useState([]);
  const [isSearchingCamps, setIsSearchingCamps] = useState(false);
  const [showCampaignFilter, setShowCampaignFilter] = useState(false);
  const [datePickerActive, setdatePickerActive] = useState(false);
  const [skip, setSkip] = useState(0);
  const [hasMoreReports, setHasMoreReports] = useState(true);
  const [isExportWindowActive, setisExportWindowActive] = useState(false);
  const [fileName, setFileName] = useState("");
  const isLoadingMore = useRef(false);
  const debounceRef = useRef(null);
  const startTimeRef = useRef(startTime);
  const endTimeRef = useRef(endTime);
  const tableContainerRef = useRef(null);
  const [currency, setCurrency] = useState(storageManager.getCurrency());

  const timezones = {
    united_states: "America/New_York",
    usa: "America/New_York",
    canada: "America/Toronto",
    mexico: "America/Mexico_City",
    costa_rica: "America/Costa_Rica",
    cuba: "America/Havana",
    dominican_republic: "America/Santo_Domingo",
    panama: "America/Panama",

    brazil: "America/Sao_Paulo",
    argentina: "America/Argentina/Buenos_Aires",
    chile: "America/Santiago",
    colombia: "America/Bogota",
    peru: "America/Lima",
    venezuela: "America/Caracas",
    ecuador: "America/Guayaquil",
    bolivia: "America/La_Paz",

    united_kingdom: "Europe/London",
    uk: "Europe/London",
    germany: "Europe/Berlin",
    france: "Europe/Paris",
    italy: "Europe/Rome",
    spain: "Europe/Madrid",
    russia: "Europe/Moscow",
    netherlands: "Europe/Amsterdam",
    switzerland: "Europe/Zurich",
    turkey: "Europe/Istanbul",
    greece: "Europe/Athens",
    sweden: "Europe/Stockholm",
    norway: "Europe/Oslo",
    finland: "Europe/Helsinki",
    poland: "Europe/Warsaw",
    portugal: "Europe/Lisbon",
    ireland: "Europe/Dublin",
    austria: "Europe/Vienna",
    belgium: "Europe/Brussels",
    denmark: "Europe/Copenhagen",
    czech_republic: "Europe/Prague",
    hungary: "Europe/Budapest",
    ukraine: "Europe/Kyiv",
    romania: "Europe/Bucharest",

    india: "Asia/Kolkata",
    japan: "Asia/Tokyo",
    china: "Asia/Shanghai",
    singapore: "Asia/Singapore",
    indonesia: "Asia/Jakarta",
    south_korea: "Asia/Seoul",
    saudi_arabia: "Asia/Riyadh",
    uae: "Asia/Dubai",
    pakistan: "Asia/Karachi",
    bangladesh: "Asia/Dhaka",
    sri_lanka: "Asia/Colombo",
    nepal: "Asia/Kathmandu",
    afghanistan: "Asia/Kabul",
    thailand: "Asia/Bangkok",
    vietnam: "Asia/Ho_Chi_Minh",
    philippines: "Asia/Manila",
    malaysia: "Asia/Kuala_Lumpur",
    iran: "Asia/Tehran",
    israel: "Asia/Jerusalem",

    south_africa: "Africa/Johannesburg",
    egypt: "Africa/Cairo",
    nigeria: "Africa/Lagos",
    kenya: "Africa/Nairobi",
    ghana: "Africa/Accra",
    morocco: "Africa/Casablanca",
    algeria: "Africa/Algiers",
    tanzania: "Africa/Dar_es_Salaam",
    ethiopia: "Africa/Addis_Ababa",
    uganda: "Africa/Kampala",
    sudan: "Africa/Khartoum",
    zimbabwe: "Africa/Harare",

    australia: "Australia/Sydney",
    new_zealand: "Pacific/Auckland",
    fiji: "Pacific/Fiji",
    samoa: "Pacific/Apia",
  };

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    if (location.state && location.state.id) {
      setCampIds([
        { campName: location.state.campName, id: location.state.id },
      ]);
    }

    api
      .get(`/api/publisher/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem(
          "PublisherInfo",
          JSON.stringify(response.data.data)
        );
        const campId = location?.state?.id || "";
        api
          .get("/api/reports?campIds=" + campId + "&filterByGoals=false")
          .then((response) => {
            setSummaryInfo(response.data.data);
            settabelLoader(false);
            setfetchingData(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [location.state, navigate, showToast]);

  const handleCheckboxChange = (name) => {
    setFilters((prev) =>
      prev.map((filter) =>
        filter.name === name ? { ...filter, state: !filter.state } : filter
      )
    );
  };

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const isOnlygoalNamesSelected = () => {
    const goalNameFilter = filters.filter(
      (filter) => filter.name === "goalName"
    );
    let isgoalNameSelected = goalNameFilter[0].state;
    if (!isgoalNameSelected) return false;
    filters.forEach((filter) => {
      if (filter.name !== "goalName" && filter.state) {
        isgoalNameSelected = false;
      }
    });
    return isgoalNameSelected;
  };

  const isNoFilter = () => {
    let result = true;
    filters.forEach((filter) => {
      if (filter.state) {
        result = false;
      }
    });
    return result;
  };

  const isClickReportsNeeded = () => {
    const result = filters.some(
      (filter) =>
        [
          "affClickId",
          "subAffId",
          "fbclid",
          "source",
          "click_id",
          "clickedAt",
          "gaid",
          "sub2",
          "sub3",
          "sub4",
          "sub5",
          "sub6",
          "sub7",
          "sub8",
          "ip",
          "isp",
          "userAgent",
        ].includes(filter.name) && filter.state
    );
    return result;
  };

  const isConvReportsNeeded = () => {
    const result = filters.some(
      (filter) =>
        ["timeGap", "trackedAt", "value", "goalName"].includes(filter.name) &&
        filter.state
    );
    return result;
  };

  const numberOfFiltersSelected = () => {
    let i = 0;
    filters.forEach((filter) => {
      if (filter.state) i++;
    });
    return i;
  };

  const handelFiltersSaveBtn = async (startDate, endDate) => {
    try {
      if (fetchingData) return;
      setfetchingData(true);
      settabelLoader(true);
      if (isNoFilter()) {
        setisFiltersWindowActive(false);
        await fetchReports(
          "/api/reports",
          { filterByGoals: false },
          false,
          "summary",
          "summaryNoGoals",
          startDate,
          endDate,
          timezone
        );
      } else if (isOnlygoalNamesSelected()) {
        setisFiltersWindowActive(false);
        await fetchReports(
          "/api/reports",
          { filterByGoals: true },
          true,
          "summary",
          "summaryGoals",
          startDate,
          endDate,
          timezone
        );
      } else if (isConvReportsNeeded()) {
        if (numberOfFiltersSelected() < 5) {
          showToast({
            status: "error",
            message: "Please select at least 5 filters for a detailed report.",
          });
          return;
        }
        setisFiltersWindowActive(false);
        await fetchReports(
          "/api/reports/all",
          {
            onlyConv: true,
            limit: reportLoadLimit,
          },
          false,
          "reports",
          "reportsOnlyConv",
          startDate,
          endDate,
          timezone
        );
      } else if (isClickReportsNeeded()) {
        if (numberOfFiltersSelected() < 5) {
          showToast({
            status: "error",
            message: "Please select at least 5 filters for a detailed report.",
          });
          return;
        }
        setisFiltersWindowActive(false);
        await fetchReports(
          "/api/reports/all",
          { limit: reportLoadLimit },
          false,
          "reports",
          "reportsAll",
          startDate,
          endDate,
          timezone
        );
      }
    } catch (err) {
      showToast({
        status: "error",
        message: "An error occurred while fetching data.",
      });
    } finally {
      settabelLoader(false);
      setfetchingData(false);
    }
  };

  const fetchReports = async (
    endpoint,
    params,
    includegoalNames = false,
    view = null,
    tohitName = null,
    startDate = null,
    endDate = null,
    timezone = null,
  ) => {
    try {
      const campIdsChanged =
        JSON.stringify(campIds) !== JSON.stringify(prevCampIds);

      const startChanged = startDate !== prevStartTime;
      const endChanged = endDate !== prevEndTime;
      const hitChanged = tohitName !== lastApiHit;
      const timezoneChanged = timezone !== prevTimezone;

      if (campIdsChanged || startChanged || endChanged || hitChanged || timezoneChanged) {
        params.campIds = campIds.map((camp) => camp.id).join(",");
        params.startDate = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        params.endDate = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        params.timezone = timezone;

        const response = await api.get(endpoint, { params });

        if (view === "summary") {
          setSummaryInfo(response.data.data || []);
          setSkip(0);
          setReports([]);
        } else if (view === "reports") {
          setReports(response.data.data || []);
          setSummaryInfo([]);
          setSkip(reportLoadLimit);
          setHasMoreReports(response.data.data.length === reportLoadLimit);

          isLoadingMore.current = false;
          settabelLoader(false);
        }

        setLastApiHit(tohitName);
        setPrevCampIds(campIds);
        setPrevStartTime(startDate);
        setPrevEndTime(endDate);
        setPrevTimezone(timezone);
      }

      // Apply view changes
      if (view === "summary") {
        setincludegoalNamesInSummary(includegoalNames);
        setToShow("summary");
      } else if (view === "reports") {

        const newActiveFilters = filters.filter((filter) => filter.state);

        const customOrder = [
          "campName",
          "campID",
          "affClickId",
          "subAffId",
          "fbclid",
          "goalName",
          "clickedAt",
          "trackedAt",
          "value",
          "timeGap",
          "source",
          "gaid",
          "click_id",
          "sub2",
          "sub3",
          "sub4",
          "sub5",
          "sub6",
          "sub7",
          "sub8",
          "ip",
          "isp",
          "country",
          "userAgent",
        ];

        newActiveFilters.sort(
          (a, b) => customOrder.indexOf(a.name) - customOrder.indexOf(b.name)
        );

        setActiveFilters(newActiveFilters);
        setToShow("reports");
        setfetchingData(false);
      }

    } catch (err) {
      showToast({
        status: "error",
        message: err?.response?.data?.message || "Unable to load data.",
      });
    }
  };

  const formatTimeGap = (ms) => {
    if (ms < 1000) return `${ms} ms`;
    let seconds = Math.floor(ms / 1000);
    if (seconds < 60) return `${seconds} s`;

    let minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min ${seconds % 60}s`;

    let hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr ${minutes % 60} min`;

    let days = Math.floor(hours / 24);
    return `${days} d ${hours % 24} hr`;
  };

  const currencyOrder = ["USD", "EUR", "INR"];

  const switchCurrency = () => {
    const current = currency || "USD";
    const currentIndex = currencyOrder.indexOf(current);

    const nextIndex =
      currentIndex === -1
        ? 0
        : (currentIndex + 1) % currencyOrder.length;

    const nextCurrency = currencyOrder[nextIndex];
    setCurrency(nextCurrency);
  };

  const exportTableToCSV = (filename) => {
    const table = document.querySelector(".report-table");
    if (!table) {
      showToast({ status: "error", message: "Table not found!" });
      return;
    }

    let csv = [];
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      let rowData = [];
      row.querySelectorAll("th, td").forEach((cell) => {
        let cellText = cell.innerText.replace(/"/g, '""');
        rowData.push(`"${cellText}"`);
      });
      csv.push(rowData.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");

    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handelFinalExportClick = () => {
    const fName = sanitizeInput(fileName.trim());
    if (!fName) return;
    exportTableToCSV(sanitizeInput(fileName.trim()));
    setFileName("");
    setisExportWindowActive(false);
  }

  const handelCampClick = (campaign) => {
    setCampaignSearchText("");
    setcampSearchResult([]);
    setCampIds((prev) => {
      const isExist = prev.some((camp) => camp.id === campaign.campaignId);

      if (isExist) {
        return prev.filter((camp) => camp.id !== campaign.campaignId);
      } else {
        return [
          ...prev,
          {
            campName: campaign.name,
            id: campaign.campaignId,
          },
        ];
      }
    });
  };

  const handelCampSearchInpChnage = (e) => {
    const sText = sanitizeInput(e.target.value);
    setCampaignSearchText(sText);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (sText.length >= 3) {
      setIsSearchingCamps(true);

      debounceRef.current = setTimeout(() => {
        api
          .get(`/api/campaign/search?searchText=${sText}&filter=approved`)
          .then((response) => {
            if (response.data.status) {
              setcampSearchResult(response.data.campaigns);
            }
          })
          .catch((err) => {
            showToast({
              status: "error",
              message:
                err.response?.data?.message ||
                "Something went wrong while searching.",
            });
          })
          .finally(() => {
            setIsSearchingCamps(false);
          });
      }, 1500);
    }
  };

  const handlePrevMonth = () => {
    setCurrentMonth((prev) => prev.clone().subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentMonth((prev) => prev.clone().add(1, "month"));
  };

  const generateWeeks = () => {
    const startOfMonth = currentMonth.clone().startOf("month");
    const endOfMonth = currentMonth.clone().endOf("month");
    const startDay = startOfMonth.day();
    const daysInMonth = endOfMonth.date();

    let daysArray = [];
    let weeks = [];

    for (let i = startDay - 1; i >= 0; i--) {
      daysArray.push({
        date: startOfMonth.clone().subtract(i + 1, "day"),
        faded: true,
      });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push({ date: startOfMonth.clone().date(i), faded: false });
    }

    for (let i = 0; i < daysArray.length; i += 7) {
      weeks.push(daysArray.slice(i, i + 7));
    }

    return weeks;
  };

  const handleDateClick = (date) => {
    const selectedDate = date.format("DD-MM-YYYY");

    if (!selectedStartTime || (selectedStartTime && selectedEndTime)) {
      setselectedStartTime(selectedDate);
      setselectedEndTime(null);
    } else if (
      !selectedEndTime &&
      moment(selectedDate, "DD-MM-YYYY").isAfter(
        moment(selectedStartTime, "DD-MM-YYYY")
      )
    ) {
      setselectedEndTime(selectedDate);
    } else {
      setselectedStartTime(selectedDate);
      setselectedEndTime(null);
    }
  };

  const getDateClass = (date) => {
    if (!selectedStartTime) return "";

    const formattedDate = date.format("DD-MM-YYYY");
    if (
      formattedDate === selectedStartTime ||
      formattedDate === selectedEndTime
    )
      return "selected";

    if (selectedStartTime && selectedEndTime) {
      return moment(formattedDate, "DD-MM-YYYY").isBetween(
        moment(selectedStartTime, "DD-MM-YYYY"),
        moment(selectedEndTime, "DD-MM-YYYY"),
        null,
        "[]"
      )
        ? "s-b"
        : "";
    }

    return "";
  };

  const applySelection = () => {
    startTimeRef.current = selectedStartTime;
    endTimeRef.current = selectedEndTime || selectedStartTime;

    setStartTime(startTimeRef.current);
    setEndTime(endTimeRef.current);
    handelFiltersSaveBtn(startTimeRef.current, endTimeRef.current);
    setdatePickerActive(false);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;

    const handleScroll = async () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold =
        document.documentElement.scrollHeight - 300;

      if (scrollPosition >= threshold && hasMoreReports) {
        if (isLoadingMore.current) return;
        if (fetchingData) return;
        if (toShow !== "reports") return;
        isLoadingMore.current = true;
        settabelLoader(false);
        setfetchingData(true);

        const isConvReportsNeeded = () => {
          const result = filters.some(
            (filter) =>
              ["timeGap", "trackedAt", "value", "goalName"].includes(filter.name) &&
              filter.state
          );
          return result;
        };

        let params = {};
        params.onlyConv = isConvReportsNeeded();
        params.limit = reportLoadLimit;
        params.skip = skip;
        params.campIds = campIds.map((camp) => camp.id).join(",");
        params.startDate = moment(startTime, "DD-MM-YYYY").format("YYYY-MM-DD");
        params.endDate = moment(endTime, "DD-MM-YYYY").format("YYYY-MM-DD");
        params.timezone = timezone;

        const response = await api.get("/api/reports/all", { params });

        const newData = response.data.data || [];
        setReports((prev) => [...prev, ...newData]);
        setSkip(skip + reportLoadLimit);
        setHasMoreReports(newData.length === reportLoadLimit);
        isLoadingMore.current = false;
        settabelLoader(false);
        setfetchingData(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMoreReports, isLoadingMore, fetchingData, toShow, campIds, skip, startTime, endTime, filters, timezone]);

  return (
    <div className="reports__page">
      <SideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        campaignOpenInital={false}
        accManagerName={userInfo.adminInfo?.name}
        accManagerEmail={userInfo.adminInfo?.email}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Reports</h2>
            <p>Get your campaigns reports..</p>
          </div>
          <button onClick={() => setisExportWindowActive("true")}>
            <Icon name="Document" className="onLeft" />
            Export
          </button>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Reports</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        <div className={`exportModal-overlay ${isExportWindowActive && "active"}`} onClick={() => setisExportWindowActive(!isExportWindowActive)}></div>
        <div className={`exportModal-content ${isExportWindowActive && "active"}`}>
          <h2 className="exportModal-title">Export Reports</h2>
          <p className="exportModal-subtitle">Enter a file name to export your reports as.</p>

          <input
            type="text"
            placeholder="Enter file name..."
            value={fileName}
            onChange={(e) => sanitizeInput(setFileName(e.target.value))}
            className="exportModal-input"
          />

          <div className="exportModal-buttons">
            <button className="exportModal-btn cancel" onClick={() => setisExportWindowActive(!isExportWindowActive)}>
              <Icon name="Xmark" />
              Cancel
            </button>

            <button
              className="exportModal-btn export"
              onClick={handelFinalExportClick}
              disabled={!fileName.trim()}
            >
              <Icon name="Document" />
              Export
            </button>
          </div>
        </div>

        <div
          className={`background-shadow mobile ${datePickerActive ? "active" : ""
            }`}
        ></div>

        <div className="top-options">
          <div
            className="date-range"
            onClick={() => setdatePickerActive(!datePickerActive)}
          >
            <Icon name="CalendarDateRange" />
            <span className="date">
              {startTime === endTime
                ? `${moment(startTime, "DD-MM-YYYY").format("DD MMMM YYYY")} ${startTime ===
                  moment
                    .tz(getTimezoneByCountry(country))
                    .startOf("day")
                    .format("DD-MM-YYYY")
                  ? "(Today)"
                  : ""
                }`
                : `${moment(startTime, "DD-MM-YYYY").format(
                  "DD MMMM YYYY"
                )} - ${moment(endTime, "DD-MM-YYYY").format("DD MMMM YYYY")}`}
            </span>
          </div>
          <button
            className="filter-btn"
            onClick={() => setisFiltersWindowActive(true)}
          >
            <Icon name="Funnel" />
            Filters
          </button>

          <div
            className={`date-range-container ${datePickerActive ? "active" : ""
              }`}
          >
            <div className="calender">
              <div className="top-sec">
                <button onClick={handlePrevMonth}>
                  <Icon name="ChevronLeft" />
                </button>
                <span>{currentMonth.format("MMM YYYY")}</span>
                <button onClick={handleNextMonth}>
                  <Icon name="ChevronRight" />
                </button>
              </div>
              <div className="weeks-label">
                {["S", "M", "T", "W", "T", "F", "S"].map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
              </div>
              <div className="days-container">
                {generateWeeks().map((week, index) => (
                  <div key={index} className="week-line">
                    {week.map(({ date, faded }, idx) => (
                      <span
                        key={idx}
                        className={`${faded ? "faded" : ""} ${getDateClass(
                          date
                        )}`}
                        onClick={() => !faded && handleDateClick(date)}
                      >
                        {date.date()}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            <div className="bottom-container">
              <button onClick={() => setdatePickerActive(false)}>Close</button>
              <button onClick={applySelection}>Apply</button>
            </div>
          </div>
        </div>

        <div
          className={`background-shadow above-side-nav ${isFiltersWindowActive ? "active" : ""
            }`}
        ></div>
        <div
          className={`filters-container ${isFiltersWindowActive ? "active" : ""
            }`}
        >
          <div className="top">
            <h2>Filters</h2>
          </div>

          <div className="filters-group">
            <div className="filter-item">
              <label className="filter-label">Campaign</label>

              <div className="filter-box">
                <input
                  type="text"
                  placeholder="Filter by Campaign"
                  autoComplete="off"
                  value={campaignSearchText}
                  onChange={handelCampSearchInpChnage}
                  onFocus={() => setShowCampaignFilter(true)}
                />

                <div
                  className={`filter-options ${((campSearchResult &&
                    campSearchResult.length > 0 &&
                    campaignSearchText.length > 0) ||
                    (isSearchingCamps && campaignSearchText.length > 0)) &&
                    showCampaignFilter
                    ? "active"
                    : ""
                    }`}
                >
                  {!isSearchingCamps &&
                    campSearchResult &&
                    campSearchResult.length > 0 &&
                    campSearchResult.map((camp) => (
                      <div
                        key={camp.campaignId}
                        className="filter-option"
                        onClick={() => {
                          handelCampClick(camp);
                          setShowCampaignFilter(false);
                        }}
                      >
                        <span className="option-title">{camp.name}</span>
                        <span className="option-sub">{camp.campaignId}</span>
                      </div>
                    ))}

                  {isSearchingCamps && (
                    <div className="filter-message">
                      <Icon name="ArrowPath" className="spin" />
                      <span>Searching...</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="filter-item">
              <label className="filter-label">Timezone</label>

              <div className="filter-box">
                <input
                  type="text"
                  placeholder="Select Timezone"
                  value={timezone}
                  readOnly
                  onClick={() => setShowTimezoneDropdown((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                />

                <div className={`filter-options ${showTimezoneDropdown ? "active" : ""}`}>
                  {Object.entries(timezones).map(([key, value]) => (
                    <div
                      key={key}
                      className="filter-option"
                      onClick={() => {
                        setTimezone(value);
                        setShowTimezoneDropdown(false);
                      }}
                    >
                      <span className="option-title">
                        {key.replace(/_/g, " ").toUpperCase()}
                      </span>
                      <span className="option-sub">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="filters">
            {filters.map((filter, index) => (
              <div key={index} className="filter">
                <div
                  className={`check-box ${filter.state ? "checked" : ""}`}
                  onClick={() => handleCheckboxChange(filter.name)}
                >
                  <Icon name={filter.state ? "CheckDark" : "CheckLight"} />
                </div>
                <span>{filter.label}</span>
              </div>
            ))}
          </div>
          {campIds && campIds.length > 0 ? (
            <span className="campsShowingText">
              <Icon name="InformationCircle" />
              {campIds === prevCampIds
                ? "Showing results for"
                : "After saving it will show results for"}{" "}
              {campIds.map((camp) => camp.campName).join(", ")}{" "}
              {campIds.length === 1 ? "camp" : "camps"} only.
            </span>
          ) : (
            ""
          )}
          <div className="bottom">
            <button onClick={() => setisFiltersWindowActive(false)}>
              Close
            </button>
            <button onClick={() => handelFiltersSaveBtn(startTime, endTime)}>
              Save
            </button>
          </div>
        </div>

        <div className="table-container" ref={tableContainerRef}>
          <table className="report-table">
            <thead>
              {toShow === "summary" ? (
                <tr>
                  <th>Name</th>
                  {includegoalNamesInSummary && <th>Goal</th>}
                  <th>Clicks</th>
                  <th>U. Clicks</th>
                  <th>Conversions</th>
                  <th>CR Rate</th>
                  <th>Revenue <Icon name={"ArrowLeftRight"} className={"currencySwitcher"} onClick={switchCurrency} /></th>
                </tr>
              ) : (
                toShow === "reports" && (
                  <tr>
                    {activeFilters.map((filter) => {
                      return filter.state && filter.isMoney ? (
                        <th key={filter.name}>{filter.label} <Icon name={"ArrowLeftRight"} className={"currencySwitcher"} onClick={switchCurrency} /></th>
                      ) : filter.state ? (
                        <th key={filter.name}>{filter.label}</th>
                      ) : (
                        ""
                      );
                    })}
                  </tr>
                )
              )}
            </thead>
            <tbody>
              {toShow === "summary" ? (
                summaryInfo && summaryInfo.length > 0 ? (
                  summaryInfo.map((info) => (
                    <tr
                      key={info.goalName ? info.name + info.goalName : info.name}
                    >
                      <td>{info.name}</td>
                      {includegoalNamesInSummary && <td>{info.goalName}</td>}
                      <td>{info.clicks}</td>
                      <td>{info.uniqueClicks}</td>
                      <td>{info.conversions}</td>
                      <td>{info.conversionRate}</td>
                      <td>{convertCurrency(info.revenue, userInfo.currency || "USD", currency)}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="center">
                    <td colSpan="7">No Data</td>
                  </tr>
                )
              ) : toShow === "reports" ? (
                reports && reports.length > 0 ? (
                  reports.map((report, index) => (
                    <tr key={index}>
                      {activeFilters.map((filter) => (
                        <td key={filter.name}>
                          {filter.isTime
                            ? moment(report[filter.name])
                              .tz(timezone)
                              .format("DD MMM YYYY, h:mm a ")
                            : filter.isTimeGap
                              ? formatTimeGap(report[filter.name])
                              : filter.name === "value"
                                ? convertCurrency(
                                  report[filter.name],
                                  report.currency,
                                  currency
                                )
                                : filter.isSubParm
                                  ? report.subParms ? report.subParms[filter.name] || "-" : "-"
                                  : report[filter.name]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr className="center">
                    <td>No Data</td>
                  </tr>
                )
              ) : null}
            </tbody>
          </table>
          <div className={`table-loader ${tabelLoader ? "active" : ""}`}>
            <Icon name="ArrowPath" className="spin" />
            <span>Please wait while we're updating table.</span>
          </div>

          <div className={`more-loading ${fetchingData && !tabelLoader ? "active" : ""}`}>
            {fetchingData && !tabelLoader && (
              <>
                <Icon name="ArrowPath" className="spin" />
                <span>Loading more data...</span>
              </>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReportsPage;
